"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoaderComponent = void 0;
const react_1 = __importDefault(require("react"));
const pageLoaderComponent_module_css_1 = __importDefault(require("./pageLoaderComponent.module.css"));
const antd_1 = require("antd");
const PageLoaderComponent = (props) => {
    let { size } = props;
    if (!size) {
        size = "default";
    }
    return (react_1.default.createElement("div", { className: pageLoaderComponent_module_css_1.default.pageLoaderContainer },
        react_1.default.createElement(antd_1.Spin, { size: size }),
        props.children));
};
exports.PageLoaderComponent = PageLoaderComponent;
exports.default = exports.PageLoaderComponent;
